import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UsersTab.css';
import UserStatisticsTab from './UserStatisticsTab';
import UserBalanceSubTab from './UserBalanceSubTab';
import PromoCodesSubTab from './PromoCodesSubTab';
import UserInviteProgressSubTab from './UserInviteProgressSubTab';
import UserDailyStatisticsSubTab from './UserDailyStatisticsSubTab';

const API_URL = process.env.REACT_APP_API_URL || '';

function UsersTab() {
  const [activeSubTab, setActiveSubTab] = useState('users');
  const [users, setUsers] = useState([]);
  const [topics, setTopics] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({ telegram_id: '', category: '', topic_id: '', subscription_id: '', referrer_telegram_id: '', promo_code_id: '', tg_username: '' });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [usersRes, topicsRes, subscriptionsRes] = await Promise.all([
        axios.get(`${API_URL}/api/users`),
        axios.get(`${API_URL}/api/topics`),
        axios.get(`${API_URL}/api/subscriptions`)
      ]);
      setUsers(usersRes.data);
      setTopics(topicsRes.data);
      setSubscriptions(subscriptionsRes.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке данных: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        telegram_id: parseInt(formData.telegram_id),
        category: formData.category,
        topic_id: parseInt(formData.topic_id),
        subscription_id: formData.subscription_id ? parseInt(formData.subscription_id) : null,
        referrer_telegram_id: formData.referrer_telegram_id ? parseInt(formData.referrer_telegram_id) : null,
        promo_code_id: formData.promo_code_id ? parseInt(formData.promo_code_id) : null,
        tg_username: formData.tg_username || null
      };
      
      if (editingUser) {
        await axios.put(`${API_URL}/api/users/${editingUser.id}`, payload);
        setEditingUser(null);
      } else {
        await axios.post(`${API_URL}/api/users`, payload);
      }
      setShowForm(false);
      setFormData({ telegram_id: '', category: '', topic_id: '', subscription_id: '', referrer_telegram_id: '', promo_code_id: '', tg_username: '' });
      fetchData();
    } catch (err) {
      setError('Ошибка при сохранении пользователя: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить этого пользователя?')) {
      try {
        await axios.delete(`${API_URL}/api/users/${id}`);
        fetchData();
      } catch (err) {
        setError('Ошибка при удалении пользователя: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingUser(null);
    setFormData({ telegram_id: '', category: '', topic_id: '', subscription_id: '', referrer_telegram_id: '', promo_code_id: '' });
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      telegram_id: user.telegram_id.toString(),
      category: user.category,
      topic_id: user.topic_id.toString(),
      subscription_id: user.subscription_id ? user.subscription_id.toString() : '',
      referrer_telegram_id: user.referrer_telegram_id ? user.referrer_telegram_id.toString() : '',
      promo_code_id: user.promo_code_id ? user.promo_code_id.toString() : '',
      tg_username: user.tg_username || ''
    });
    setShowForm(true);
  };

  const getTopicTitle = (topicId) => {
    const topic = topics.find(t => t.id === topicId);
    return topic ? topic.title : `ID: ${topicId}`;
  };

  const getCategoryBadgeClass = (category) => {
    switch (category) {
      case 'Junior':
        return 'category-badge junior';
      case 'Middle':
        return 'category-badge middle';
      case 'Senior':
        return 'category-badge senior';
      default:
        return 'category-badge';
    }
  };

  if (loading && activeSubTab === 'users') {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="users-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('users')}
        >
          Пользователи
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'statistics' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('statistics')}
        >
          Статистика пользователей
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'balance' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('balance')}
        >
          Баланс пользователей
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'promo-codes' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('promo-codes')}
        >
          Промокоды
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'invite-progress' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('invite-progress')}
        >
          Прогресс приглашений
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'daily-statistics' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('daily-statistics')}
        >
          Ежедневная статистика
        </button>
      </div>

      {activeSubTab === 'statistics' ? (
        <UserStatisticsTab />
      ) : activeSubTab === 'balance' ? (
        <UserBalanceSubTab />
      ) : activeSubTab === 'promo-codes' ? (
        <PromoCodesSubTab />
      ) : activeSubTab === 'invite-progress' ? (
        <UserInviteProgressSubTab />
      ) : activeSubTab === 'daily-statistics' ? (
        <UserDailyStatisticsSubTab />
      ) : (
        <>
          <div className="tab-header">
            <h2>Управление пользователями</h2>
            {!showForm && (
              <button className="btn btn-primary" onClick={() => setShowForm(true)}>
                + Добавить пользователя
              </button>
            )}
          </div>

          {error && <div className="error-message">{error}</div>}

          {showForm && (
        <div className="form-container">
          <h3>{editingUser ? 'Редактировать пользователя' : 'Добавить нового пользователя'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="telegram_id">Telegram ID *</label>
              <input
                type="number"
                id="telegram_id"
                value={formData.telegram_id}
                onChange={(e) => setFormData({ ...formData, telegram_id: e.target.value })}
                required
                min="1"
                placeholder="Введите Telegram ID"
              />
            </div>
            <div className="form-group">
              <label htmlFor="category">Категория *</label>
              <select
                id="category"
                value={formData.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                required
              >
                <option value="">Выберите категорию</option>
                <option value="Junior">Junior</option>
                <option value="Middle">Middle</option>
                <option value="Senior">Senior</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="topic_id">Тема *</label>
              <select
                id="topic_id"
                value={formData.topic_id}
                onChange={(e) => setFormData({ ...formData, topic_id: e.target.value })}
                required
                disabled={topics.length === 0}
              >
                <option value="">Выберите тему</option>
                {topics.map((topic) => (
                  <option key={topic.id} value={topic.id}>
                    {topic.title}
                  </option>
                ))}
              </select>
              {topics.length === 0 && (
                <small className="form-hint">
                  Сначала создайте тему в разделе "Темы"
                </small>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="subscription_id">Подписка</label>
              <select
                id="subscription_id"
                value={formData.subscription_id}
                onChange={(e) => setFormData({ ...formData, subscription_id: e.target.value })}
              >
                <option value="">Нет подписки</option>
                {subscriptions.map((subscription) => (
                  <option key={subscription.id} value={subscription.id}>
                    {subscription.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="referrer_telegram_id">Telegram ID пригласившего</label>
              <input
                type="number"
                id="referrer_telegram_id"
                value={formData.referrer_telegram_id}
                onChange={(e) => setFormData({ ...formData, referrer_telegram_id: e.target.value })}
                min="1"
                placeholder="Введите Telegram ID пригласившего (необязательно)"
              />
            </div>
            <div className="form-group">
              <label htmlFor="promo_code_id">ID промокода</label>
              <input
                type="number"
                id="promo_code_id"
                value={formData.promo_code_id}
                onChange={(e) => setFormData({ ...formData, promo_code_id: e.target.value })}
                min="1"
                placeholder="Введите ID промокода (необязательно)"
              />
            </div>
            <div className="form-group">
              <label htmlFor="tg_username">Telegram Username</label>
              <input
                type="text"
                id="tg_username"
                value={formData.tg_username}
                onChange={(e) => setFormData({ ...formData, tg_username: e.target.value })}
                placeholder="Введите username (необязательно, без @)"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingUser ? 'Сохранить' : 'Создать'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Telegram ID</th>
              <th>Username</th>
              <th>Категория</th>
              <th>Тема</th>
              <th>Подписка</th>
              <th>Пригласивший</th>
              <th>Промокод</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="9" className="empty-state">
                  Нет пользователей. Добавьте первого пользователя.
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.telegram_id}</td>
                  <td>{user.tg_username ? `@${user.tg_username}` : '-'}</td>
                  <td>
                    <span className={getCategoryBadgeClass(user.category)}>
                      {user.category}
                    </span>
                  </td>
                  <td>{user.topic_title || getTopicTitle(user.topic_id)}</td>
                  <td>{user.subscription_name || 'Нет подписки'}</td>
                  <td>{user.referrer_telegram_id || '-'}</td>
                  <td>{user.promo_code_name || (user.promo_code_id ? `ID: ${user.promo_code_id}` : '-')}</td>
                  <td>
                    <button
                      className="btn-icon btn-edit"
                      onClick={() => handleEdit(user)}
                      title="Редактировать"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(user.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
        </>
      )}
    </div>
  );
}

export default UsersTab;

